import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ri-resolution-ui-callback',
  standalone: true,
  templateUrl: './callback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallbackComponent {}
